import { motion } from "framer-motion";
import { Stethoscope, Sparkles, SmilePlus, PawPrint, ArrowUpRight } from "lucide-react";
import { ChapterHeading } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const SEGMENTS = [
  {
    icon: Stethoscope,
    title: "Clínicas médicas",
    text: "Confirmações automáticas, triagem inteligente e pacientes que nunca ficam sem resposta.",
    tag: "consultas & retornos",
  },
  {
    icon: Sparkles,
    title: "Estética & beleza",
    text: "Agenda cheia com lembretes, lista de espera ativa e recuperação de clientes inativas.",
    tag: "sessões & pacotes",
  },
  {
    icon: SmilePlus,
    title: "Odontologia",
    text: "Menos cadeiras vazias com confirmação, remarcação instantânea e follow-up de orçamentos.",
    tag: "avaliações & tratamentos",
  },
  {
    icon: PawPrint,
    title: "Petshops & veterinárias",
    text: "Banho, tosa e consultas organizados sem esforço — com lembrete até para o reforço da vacina.",
    tag: "banho, tosa & consultas",
  },
];

const onSpotlight = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
};

export default function Segments() {
  return (
    <section id="segmentos" data-testid="segments-section" className="relative py-28 sm:py-36">
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        <ChapterHeading
          index="05"
          eyebrow="Feito para o seu segmento"
          lines={["Não é para todo mundo.", "É para o seu negócio."]}
          sub="A CliniAtiva foi desenhada para negócios locais de serviço, onde atendimento e agenda fazem parte do dia a dia."
        />

        <div className="mt-16 grid gap-5 sm:grid-cols-2">
          {SEGMENTS.map((s, i) => (
            <motion.button
              key={s.title}
              data-testid={`segment-card-${i + 1}`}
              onMouseMove={onSpotlight}
              onClick={() => scrollToId("demonstracao")}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -5 }}
              className="spotlight-card group relative rounded-3xl border border-[var(--line)] bg-[var(--card)] p-8 text-left transition-[box-shadow,border-color] duration-300 hover:border-[var(--brand)]/50 hover:shadow-[0_24px_50px_-24px_rgba(18,60,74,0.35)] sm:p-10"
            >
              <div className="relative z-[2]">
                <div className="flex items-start justify-between">
                  <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[var(--brand)]/12 text-[var(--brand)]">
                    <s.icon className="h-7 w-7" />
                  </div>
                  <ArrowUpRight className="h-6 w-6 text-[var(--muted)] opacity-0 transition-[opacity,transform] duration-300 group-hover:translate-x-1 group-hover:opacity-100 group-hover:text-[var(--brand)]" />
                </div>
                <p className="mt-8 font-mono2 text-[10px] uppercase tracking-[0.3em] text-[var(--brand)]">{s.tag}</p>
                <h3 className="mt-3 font-display text-2xl font-bold text-[var(--ink)]">{s.title}</h3>
                <p className="mt-3 max-w-md text-sm leading-relaxed text-[var(--muted)] sm:text-base">{s.text}</p>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
